(function ($) {
  $(function () {
    var $textOverGreyBoxCollection = $('.text-over-grey-box');
    var $header = $("header");
    var $stickyNav = $(".sticky-nav");
    var hash;

    if ($textOverGreyBoxCollection.length > 0) {
      function storeHashAndRemoveHashFromUrl() {
        // Store the hash value and then remove it from the URL
        hash = window.location.hash;

        if (hash.length) {
          history.replaceState({}, document.title, window.location.pathname);
        }
      }

      function getMainNavHeight() {
        return $header.find(".main-nav").outerHeight();
      }

      function getStickyNavHeight() {
        return $stickyNav.length ? $stickyNav.outerHeight() : 0;
      }

      function getAnchorOffsetTop(anchor) {
        var $anchor = $(anchor);

        if ($anchor.length) {
          return $anchor.offset().top;
        }
      }

      function smoothScrollTo(el) {
        var currentScrollPos = $(window).scrollTop();
        var anchorOffsetTop = getAnchorOffsetTop(el);
        var scrollTopPos = anchorOffsetTop - (getStickyNavHeight() + getMainNavHeight() + 1);;

        if (currentScrollPos < anchorOffsetTop) {
          if ($(window).width() > 1023) {
            scrollTopPos = anchorOffsetTop + 1;
          } else {
            scrollTopPos = anchorOffsetTop - getMainNavHeight() + 1;
          }
        }

        $("html, body").animate(
          {
            scrollTop: scrollTopPos,
          },
          700,
          function () {
            if (hash.length) {
              history.pushState({}, document.title, hash);
            }
          }
        );
      }

      function smoothScrollOnHash() {
        if (hash.length) {
          smoothScrollTo(hash);
        }
      }

      storeHashAndRemoveHashFromUrl();
      $(window).on('load hashchange', smoothScrollOnHash);

      $textOverGreyBoxCollection.each(function () {
        var $textOverGreyBox = $(this);

        if ($textOverGreyBox.find('.media-wrapper > .col-12').length > 1) {
          $textOverGreyBox.find(' .media-wrapper').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 8000,
            fade: true,
            swipe: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            slidesToSwipe: 1,
            arrows: false,
            adaptiveHeight: false,
            dots: true,
          });
        }

        if ($textOverGreyBox.hasClass('with-timeline')) {
          $('.timeline').timeline({
            mode: 'horizontal',
            forceVerticalMode: 1,
          });
        }

        if ($textOverGreyBox.hasClass('with-two-col-cards')) {
          addGreyBoxBackground();
          $(window).on('resize', addGreyBoxBackground);

          function addGreyBoxBackground() {
            var $greyBox = $textOverGreyBox.find('.grey-box');
            var $greyBoxBackground = $('<span></span>');

            $greyBoxBackground.css(
              'height',
              `${$greyBox.find('.inner-section').first().outerHeight()}px`
            );

            if ($(window).width() < 768) {
              $greyBoxBackground.css({
                height:
                  $greyBox.find('.inner-section').first().outerHeight() +
                  $greyBox.find('.pattern__wrapper').outerHeight() / 2,
                top:
                  $greyBox.find('.inner-section').first().offset().top -
                  $greyBox.offset().top -
                  $greyBox.find('.pattern__wrapper').outerHeight() / 2,
              });
            }

            $greyBox.children('span').length &&
              $greyBox.children('span').remove();
            $greyBox.prepend($greyBoxBackground);
          }
        }
      });
    }
  });
})(jQuery);
